import React from 'react';

import styles from './InputTag.scss';
import { Tag } from './Tag';

export interface IInputTagProps {
  tags;
  placeholder?: string;
  onFocus?;
  onBlur?;
  onChange?;
  onRemoveClick?;
  value?: string;
  inputRef;
}

export class InputTag extends React.Component<IInputTagProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      tags: []
    };
  }

  public render() {
    const { tags, placeholder, onFocus, onBlur, onChange, onRemoveClick, value, inputRef } = this.props;

    return (
      <div className={styles.header}>
        <span className={styles.prefix}>To</span>
        <div className={styles.tagSpace}>
          {tags.map(tag => (
            <Tag key={`${tag.first_name}${tag.last_name}`} tag={tag} onRemoveClick={onRemoveClick} />
          ))}
          <input
            type="text"
            className={styles.input}
            placeholder={placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            ref={inputRef}
          />
        </div>
      </div>
    );
  }
}
